<template>
  <v-container>
    <div style="max-height: calc(100vh - 80px)" class="px-8 d-flex flex-column justify-center">
      <div class="py-3 pl-2 flex-grow-0 flex-shrink-0">
        <div class="text-h4 font-weight-medium">{{ $t("navbar.menu.feed") }}</div>
      </div>
      <NewPost class="my-4 mx-auto" style="width: 100%; max-width: 600px" />
      <v-dialog v-model="editPostDialog" max-width="600">
        <!-- <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            New Post
          </v-btn>
        </template> -->
        <EditPostDialog
          :editingPost="editingPost"
          @close="
            editPostDialog = false;
            editingPost = null;
          "
        />
      </v-dialog>
      <div class="flex-grow-1 px-1" style="overflow-y: auto">
        <template v-for="(post, key) in posts">
          <Poll
            v-if="post.question"
            class="my-4 mx-auto"
            :key="key"
            :poll="post"
            style="max-width: 600px"
          />
          <Post
            v-else
            class="my-4 mx-auto"
            :key="key"
            :post="post"
            style="max-width: 600px"
            @edit="editPost"
          />
        </template>
      </div>
    </div>
  </v-container>
</template>

<script>
import NewPost from "./NewPost";
import Post from "./Post";
import Poll from "./PollPost";
import EditPostDialog from "./EditPostDialog";

export default {
  name: "Feed",
  components: {
    NewPost,
    Post,
    Poll,
    EditPostDialog,
  },
  data() {
    return {
      editPostDialog: false,
      editingPost: null,
    };
  },
  created() {
    // this.$store.dispatch("observeFeed");
  },
  methods: {
    editPost(postId) {
      console.log(postId);
      this.editingPost = postId;
      this.editPostDialog = true;
    },
  },
  computed: {
    users() {
      return this.$store.getters.allUsers;
    },
    groupUsers() {
      const users = this.$store.state.trip.trip.user_ids;
      console.log("users");
      console.log(users);
      return this.users.filter((u) => !users[u.id]);
    },
    adminUsers() {
      const users = this.$store.state.trip.trip.user_ids;
      console.log(users);
      return this.users.filter((u) => users[u.id]);
    },
    posts() {
      return this.$store.getters.sortedPosts.map((post) => ({
        ...post,
        userName: this.$store.getters.getUserById(post.sender_id).name,
        userPic:
          this.$store.getters.getImageUrlById(post.sender_id) ||
          require("@/assets/profile_pic_empty.png"),
      }));
    },
  },
};
</script>
